module.exports = __webpack_public_path__ + "static/media/9n.c4523e69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/9n.svg
// module id = 159
// module chunks = 0